export const userLevels = {
  BASIC: 1,
  MANAGER: 2,
  EXECUTIVE: 3,
  EXTERNAL: 5
}
